import { render, staticRenderFns } from "./AppPhase5.vue?vue&type=template&id=e396db74&"
import script from "./AppPhase5.vue?vue&type=script&lang=js&"
export * from "./AppPhase5.vue?vue&type=script&lang=js&"
import style0 from "./AppPhase5.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports